import { FormLabel, Grid, TextField } from '@mui/material';
import { Option } from '@thro-types/leihbar';

import { Field, useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';

import { Description } from 'app/components/Description';
import StyledDropzone from 'app/components/Dropzone';
import { translations } from 'locales/i18n';

export function OptionInformation() {
  const { t } = useTranslation();

  const { errors, touched, setFieldValue, values } = useFormikContext<Option>();
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={10}>
        <Field
          as={TextField}
          name="title"
          error={touched.title && Boolean(errors.title)}
          helperText={touched.title && errors.title}
          fullWidth
          required
          label={t(translations.pages.leihbar.option.create.title())}
        />
      </Grid>
      <Grid item xs={6} md={2}>
        <Field
          as={TextField}
          name="amount"
          error={touched.amount && Boolean(errors.amount)}
          helperText={touched.amount && errors.amount}
          fullWidth
          required
          type="number"
          InputProps={{
            inputProps: { min: 1 }
          }}
          label={t(translations.pages.leihbar.option.create.count())}
        />
      </Grid>
      <Grid item xs={12}>
        <FormLabel required>{t(translations.pages.leihbar.option.create.description())}</FormLabel>
        <Field
          name="description"
          error={touched.description && Boolean(errors.description)}
          helperText={touched.description && errors.description}
          fullWidth
          required
          label={t(translations.pages.leihbar.option.create.description())}
        >
          {({ field }) => <Description field={field} />}
        </Field>
      </Grid>
      <Grid item xs={12} md={4}>
        <StyledDropzone
          name="image"
          value={values.image}
          setFieldValue={setFieldValue}
          accept={{
            'image/jpeg': ['.jpeg', '.jpg'],
            'image/png': ['.png'],
            'image/svg+xml': ['.svg']
          }}
          errors={errors}
          placeholder={t(translations.pages.leihbar.option.create.image())}
          className="optionModal__dropzone"
          showPreview
        />
      </Grid>
    </Grid>
  );
}
